<template>
    <panel-template-full :body-height="true">
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    <span>
                        <span>Controle do Lançamento</span>
                        <span> &#8226; Controle de {{ launchTitle }} </span>
                    </span>
                </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <div class="body-steps" :class="{ 'body-steps-card': dealReserves.length > 2 }">
                <div class="content-steps-manager" :style="heightValidationView">
                    <section class="sidebar-left">
                        <div class="button-list-client">
                            <ui-button design="mw-150 primary md" @click="openModalHandler">
                                <em class="fal fa-search" />
                                Buscar Cliente
                            </ui-button>

                            <span class="list-client" @click="customerListHandler">Ir para lista de clientes</span>
                        </div>

                        <div class="card-data-client">
                            <ui-card-data-client v-if="control?.deal" :data="control.deal" />
                        </div>
                        <div v-if="hasSimulation && cashFlow" class="card-data-contract">
                            <ui-button
                                design="primary md mw-150"
                                @click="printVoucherHandler">
                                Reimprimir Pagamento
                            </ui-button>
                        </div>

                        <div v-if="showContract" class="card-data-contract">
                            <ui-button
                                :loading="loader.contract"
                                design="md success"
                                @click="contractHandler">
                                Gerar Contrato
                            </ui-button>
                        </div>

                        <div
                            v-if="$route.name === 'launch.control.payment' && control?.deal?.simulation"
                            class="card-data-contract">
                            <ui-button
                                design="md success"
                                @click="handleOpenModal">
                                Análise Financeira
                            </ui-button>
                        </div>

                        <div class="ticket-reserve">
                            <ui-ticket-reserve
                                v-for="(reservation, index) in dealReserves"
                                :key="index"
                                :data="reservation"
                                :availability="control.deal.product.availability"
                            />
                        </div>
                    </section>

                    <section class="main-content">
                        <div
                            v-if="definitions && definitions.product"
                            class="title">
                            {{ definitions.product.name }}
                        </div>

                        <div class="chain-menu">
                            <ui-chain-menu2
                                :check="false"
                                :data="steps"
                                :title="launchTitle"
                                clickable
                                @input="setSteps($event)"
                            />
                        </div>

                        <slot name="step" />
                    </section>

                </div>

                <ui-search-customer-modal @deal-id="getCashFlow"/>
                <ui-cancel-reservation-modal />
                <ui-reserve-voucher />
            </div>
        </template>
    </panel-template-full>
</template>

<script>
    import { uiBreadcrumbs } from '@/components/ui'
    import { uiButton } from '@/components/ui/buttons'
    import { uiChainMenu2 } from '@/components/ui/menus'
    import uiSearchCustomerModal from '../search-customer-modal'
    import uiCardDataClient from '../card-data-client'
    import uiTicketReserve from '../ticket-reserve'
    import PanelTemplateFull from '@/templates/page-panel-full'
    import uiCancelReservationModal from '../cancel-reservation-modal'
    import uiReserveVoucher from '../reserve-voucher'
    import { launchDay } from '@/services/axios'

    import { deal } from '@/services/axios'

    import { mapActions, mapGetters } from 'vuex'

    import { defaultSteps } from '../data'

    export default {
        name: 'ui-control-steps-manager',

        components: {
            uiBreadcrumbs,
            uiButton,
            uiCardDataClient,
            uiTicketReserve,
            uiChainMenu2,
            PanelTemplateFull,
            uiSearchCustomerModal,
            uiCancelReservationModal,
            uiReserveVoucher
        },

        data() {
            return {
                loader: {
                    contract: false
                },
                unsubscribe: null,
                cashFlow: false,
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                steps: 'getSteps',
                control: 'getControl',
                definitions: 'getDefinitions'
            }),
            /**
             * Computed property que define o título da página de acordo com a rota do ponto de
             * controle configurado
             */
            launchTitle() {
                let title = ''
                switch (this.$route && this.$route.name) {
                    case 'launch.control.reservation':
                        title = 'Reserva'
                        break

                    case 'launch.control.validation':
                        title = 'Validação de Dados'
                        break

                    case 'launch.control.payment':
                        title = 'Pagamento'
                        break
                }

                return title
            },
            /**
             * Computed property que retorna as reservas do negócio/cliente selecionado
             */
            dealReserves() {
                return this.control && this.control.deal
                    ? Object.values(this.control.deal.reserves)
                        .filter(reserve => {
                            return reserve.status === 'reserved' &&
                            reserve.units.availability_id === this.definitions.launchday.availability_id
                        })
                        .map(reserve => {
                            reserve.qr_code = this.control.deal.qr_code
                            reserve.simulation = this.control.timeline[reserve.unity_id] || null

                            return reserve
                        })
                    : []
            },
            /**
             * Computed property que define se as informações de contrato serão mostradas
             * para o usuário
             */
            showContract() {
                return this.$route.name === 'launch.control.payment' &&
                    this.definitions &&
                    this.definitions.launchday &&
                    this.definitions.launchday.attributes &&
                    this.definitions.launchday.attributes.contract_selected
            },
            /**
             * Computed property que define a altura da view de acordo com a rota
             */
            heightValidationView() {
                let height = null

                if (this.$route.name === 'launch.control.validation' ||
                    this.$route.name === 'launch.control.reservation') {
                    height = 'height: 100%'
                }

                return height
            },
            hasSimulation() {
                return !!this.control?.deal?.simulation?.unity
            },
            productAvailability() {
                return this.control?.deal?.product?.availability || null;
            }
        },

        created() {
            if (!this.steps) this.setSteps(defaultSteps)

            this.$root.$on('modal-close-cancel-reservation', () => {
                this.loadControlDeal({ code: this.control.deal.id, type: 'cod' })
            })

            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe(mutation => {
                if (mutation.type === 'launchDay/SET_CONTROL_DEAL') {
                    // Caso um novo cliente tenha sido selecionado, define por quais pontos ele já passou
                    let steps = [...defaultSteps]
                    const stepRoutes = {
                        reserva: 'launch.control.reservation',
                        validacao: 'launch.control.validation',
                        pagamento: 'launch.control.payment'
                    }

                    for (let step of steps) {
                        const stepPointIds = Object.values(this.definitions.launchday_points)
                            .filter(point => point.control.name === step.tag)
                            .map(point => point.id)
                        const stepCheckins = this.control.checkins
                            .filter(checkin => stepPointIds.includes(checkin.points_id) &&
                                (step.tag !== 'chamado' || checkin.situation === 'presente'))

                        if (stepCheckins.length) {
                            step.completed = true
                            step.seted = false
                            step.editing = false
                        }

                        // Verifica se o step é referente ao controle corrente
                        if (stepRoutes[step.tag] === this.$route.name) {
                            step.editing = true
                            step.seted = true
                        }
                    }

                    this.setSteps(steps)
                }
            })
        },

        mounted() {
            if (!(this.control && this.control.deal)) this.openModalHandler()
        },

        beforeDestroy() {
            this.unsubscribe()
        },

		methods: {
            ...mapActions('launchDay', ['setSteps', 'loadControlDeal']),
            /**
             * Event handler que trato evento de quando a busca por um cliente/negócio é
             * requerida
             */
			openModalHandler() {
				this.$root.$emit('modal-open-search-customer')
			},
            /**
             * Trata o evento de quando a geração ou download de um contrato é requerida
             */
            contractHandler: async function () {
                if (!(this.control && this.control.deal)) {
                    this.$toastr.e('Nenhum negócio foi selecionado!')
                    return
                }

                try {
                    this.loader.contract = true
                    const contractId = this.definitions.launchday.attributes.contract_selected
                    const dealId = this.control.deal.id
                    await deal.getContractFromModel(contractId, dealId)
                    const response = await deal.generateContractFromModel(contractId, dealId)
                    window.open(response.data.data.url)

                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.loader.contract = false
                }
            },
            /**
             * Event handler que trata o evento de abrir a lista de clientes em uma nova aba
             */
            customerListHandler() {
                const route = this.$router.resolve({ name: 'sales.deals.list' })
				window.open(route.href, '_blank')
            },
            handleOpenModal() {
                this.$root.$emit('modal-open-financial-analysis-modal')
            },
            getCashFlow(id){
                launchDay.get('cashflow/deal_id/', id)
                    .then(response => {
                        if(response.data.length > 0){
                            this.cashFlow = response.data
                        }
                    })
                    .catch(error => console.log('error', error));
            },
            printVoucherHandler(){
                const data = this.cashFlow

                const unit = data[data.length - 1]
                const totalValue = data.reduce((sum, item) => sum + parseFloat(item.value), 0);
                let totalCost = data[data.length - 1]
                totalCost = parseFloat(totalCost.unity.cost)
                const lastPayment = data[data.length - 1]

                let payload = {
                    units: [unit.unity],
                    availability: { ...this.productAvailability },
                    entry_value: totalValue,
                    total_value: totalCost,
                    summary_value: totalValue,
                    created_at: lastPayment.created_at,
                    payments: [...data],
                    copies: 'broker'
                }

                // Verifica se a via do cliente será impressa
                if (this.definitions.launchday.attributes.via_cliente) {
                    payload.copies += ',customer'
                }

                // Verifica se a via do caixa será impressa
                if (this.definitions.launchday.attributes.via_caixa) {
                    payload.copies += ',box'
                }

                this.$root.$emit('print-payment-voucher', payload)
            }
		}
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
